import { render, staticRenderFns } from "./OrgRouter.vue?vue&type=template&id=405ac17a&"
import script from "./OrgRouter.vue?vue&type=script&lang=js&"
export * from "./OrgRouter.vue?vue&type=script&lang=js&"
import style0 from "./OrgRouter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports